module.exports = "<div ngClass=\"alert--{{type}}\" *ngIf=\"visible\">\n\t<ng-content></ng-content>\n\t<div class=\"close-icon\" (click)=\"close()\">×</div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-helper/alert/alert.html
// module id = kUp0
// module chunks = 12